/* eslint-disable camelcase */

export default {
  p_requestId: "Request ID",
  p_requestDate: "Request date",
  p_amount: "Amount",
  p_paymentSystem: "Payment system",
  p_status: "Status",
  p_wallet: "Wallet",

  status_pending: "Pending",
  status_done: "Done",
  status_canceled: "Canceled",
  status_error: "Error",

  status_detail_new: "New",
  status_detail_processing: "Processing",
  status_detail_full_filled: "Fullfilled",
  status_detail_completed: "Completed",
  status_detail_canceled: "Canceled",
  status_detail_error: "Error",

  unknown_error: "Unknown error",
  wallet_filter: "Filter by wallet",
  status_filter: "Filter by status",
  filters_title: "Filters",
  clear_all_filters: "Clear all filters",
  active_filters: "Active filters",
  show_filters: "Show filters",
  apply_filters: "Apply filters",
  no_filters_active: "No filters active",
};
